import { CurrencyPipe, DatePipe, DecimalPipe, NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { BlinkDirective } from '@zero/shared/ui-directives';
import { InstrumentDetailsLinkComponent, WatchlistToggleComponent } from '@zero/shared/ui-web-components';
import { InstrumentTopflopListItemModel } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tr[topflop-list-item]',
  templateUrl: './topflop-list-item.component.html',
  styleUrls: ['topflop-list-item.component.scss'],
  imports: [
    InstrumentDetailsLinkComponent,
    WatchlistToggleComponent,
    BlinkDirective,
    NgClass,
    RouterLink,
    DecimalPipe,
    CurrencyPipe,
    DatePipe,
    TranslocoPipe,
  ],
})
export class TopflopListItemComponent {
  @Input() public item: InstrumentTopflopListItemModel;

  public readonly commonRoutes = commonRoutes;
}
